export class PaymentError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PaymentError';
    this.message = message;
    Object.setPrototypeOf(this, PaymentError.prototype);
  }
}

export class PromoCodeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'PromoCodeError';
    this.message = message;
    Object.setPrototypeOf(this, PromoCodeError.prototype);
  }
}

export class SkillzAPIError extends Error {
  context?: Record<string, unknown>;

  constructor(message: string, context?: Record<string, unknown>) {
    super(message);
    this.name = 'SkillzAPIError';
    this.context = context;

    Object.setPrototypeOf(this, SkillzAPIError.prototype);
  }
}

export class NextJSError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'NextJSError';
    this.message = message;
    Object.setPrototypeOf(this, NextJSError.prototype);
  }
}

export class ServerSideError extends Error {
  context?: Record<string, unknown>;

  constructor(message: string, context?: Record<string, unknown>) {
    super(message);
    this.name = 'ServerSideError';
    this.context = context;
    Object.setPrototypeOf(this, ServerSideError.prototype);
  }
}
